export const PlusIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12">
		<path
			fill="currentColor"
			d="M6 0c.5523 0 1 .4477 1 1v4h4c.5523 0 1 .4477 1 1s-.4477 1-1 1H7v4c0 .5523-.4477 1-1 1s-1-.4477-1-1V7H1c-.5523 0-1-.4477-1-1s.4477-1 1-1h4V1c0-.5523.4477-1 1-1Z"
		/>
	</svg>
);
